import React, { useState, useEffect } from "react";
import { MDBInput } from "mdb-react-ui-kit";
import ReactDatetime from "react-datetime";
import Select from "react-select";

import {
  Button,
  Card,
  CardBody,
  Table,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";


import {
  SMS_DETAILED_REPORT_EXCEL,
  SMS_DETAILED_REPORT
} from "../../constants";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import axios from "axios";
import apiService from "../../variables/apiService";
import moment from "moment";
import NotificationAlert from "react-notification-alert";
import logo from "../../assets/img/logo.png";
import LoadingScreen from "react-loading-screen";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';

const localJson = localStorage.getItem("user");
const user= JSON.parse(localJson)
const Detailedreports = () => {
  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    campaignname:"",
    mobile:"",
    templateid:"",
    senderid:""
  });
  let selectedDate="";
  const [singleSelect, setsingleSelect] = useState({ value: "Outbound", label: "Outbound" }   );
 
  const [whatsappLst, setWhatsappLst] = useState([]);
  const [whatsappLstC, setWhatsappLstC] = useState([]);


  const [currentPage, setCurrentPage] = React.useState(1);

  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });

  const notificationAlertRef = React.useRef(null);
  const [errorhandle,setErrorHandle]= useState()
  const [isLoading, setIsLoading] = React.useState(false);
  const [filterList, setFilterLst] = useState([]);
  const drpdwns=[
    { value: "Inbound", label: "Inbound" },     
    { value: "Outbound", label: "Outbound" }   
   
  ]



  const validating=()=>{
    let errors = {}
    let fromdate = moment(search?.fromdate).format("YYYY-MM-DD");
    let todate = moment(search?.todate).format("YYYY-MM-DD");
    if(!search?.fromdate){
      errors.fromdate="Please Select From Date"
    }if(!search?.todate){
      errors.todate="Please Select To Date"
    }else if(todate < fromdate){
      errors.todate="To date should be greater than or equal to from date"
    }
    if(!singleSelect?.value){
      errors.singleSelect="Please Select Response"
    }
    
    

    return errors;
  }

  const getWhatsappList = (page) => {
    const isValid = validating();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length===0){
    setIsLoading(true);
    const lclStrge= localStorage.getItem("user");
    const user = JSON.parse(lclStrge);
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
    const systemid = user?.systemid;
    const type = singleSelect?.value;
   
    setCurrentPage(page);
    apiService
     // .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search?.campaignname}&template=${search?.templateid?.value}&mobile=${search.mobile}&senderid=${search?.senderid?.value}&page=` + page)
     .getData(SMS_DETAILED_REPORT + `?fromdate=${fromdate}&todate=${todate}&systemId=${systemid}&page=${page}&type=${type}`)
     
     .then((res) => {
        setWhatsappLst(res.data);
        setWhatsappLstC(res.data)
        setIsLoading(false);
        setFilterLst(res.data);
      })
      .catch((err) => {
        console.log("error===>", err);
        setWhatsappLst([]);
        setIsLoading(false);
      });
    }
  };



  const generateXcel = (page) => {
    const isValid = validating();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length===0){
    if (search?.fromdate) {
      let selectedDate = moment(search.date).format("YYYY-MM-DD");

      const lclStrge= localStorage.getItem("user");
      const user = JSON.parse(lclStrge);
      let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
      let todate = moment(search.todate).format("YYYY-MM-DD");
      const sender_id = user?.systemid;
      const type = singleSelect?.value;
      setIsLoading(true);
      setCurrentPage(page);
      apiService
      //  .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search.campaignname}&template=${search?.template}&mobile=${search.mobile}&senderid=${user.sender_id}&page=` + page)
      .getData(SMS_DETAILED_REPORT_EXCEL + `?fromdate=${fromdate}&todate=${todate}&systemId=${sender_id}&page=${page}&type=${type}`)
    
        .then((res) => {
          setIsLoading(false);
          exportToCSV(res.data.message);
        })
        .catch((err) => {
          let options = {};
          options = {
            place: "tr",
            message: err.response.data.message,
            type: "warning",

            autoDismiss: 3,
          };
          notificationAlertRef.current.notificationAlert(options);
          setIsLoading(false);
        });
      }
    } else {
      setValidate({
        message: "please enter details",
        notValid: true,
      });
    }
  };

  const exportToCSV = (apiData) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, search.fromdate + fileExtension);
  };

  

  const filterData = (e) => {
    let filter = e.target.value;
    // let a = filterList?.message.filter((item,index)=>{console.log(typeof(c)) })
    let a = whatsappLstC?.message?.filter(item => item?.msisdn?.includes(filter));
   
   setWhatsappLst({
    message:a
   })
  };

  const toDatevalidation = (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };







  return (
    <>
      <div className="content pb-0">
        <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
        <Row>
          <Col md="12">
            <Card className="mb-2">
              <CardBody>
                <NotificationAlert ref={notificationAlertRef} />
                <Row>
                
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                        setCurrentPage(1)
                       
                      }}
                    />
                     <span style={{color:"red"}}>{errorhandle?.fromdate}</span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        setSearch({ ...search, todate: val._d });
                        setCurrentPage(1)
                        toDatevalidation(val._d);
                      }}
                    
                    />
                   <span style={{color:"red"}}>{errorhandle?.todate}</span>
                  </Col>
                  <Col md="2" sm='12'>
                    <p className="category">Select </p>
                  <Select
                          className="react-select info"
                          classNamePrefix="react-select"
                          name="singleSelect"
                          value={singleSelect}
                          onChange={(value) => {setsingleSelect(value);}}
                          options={drpdwns}
                          placeholder="Select"
                        />
                        <span style={{color:"red"}}>{errorhandle?.singleSelect}</span>
                    </Col>
                    
                   
                  <Col md="2" sm="6" className="pull-right">
                  <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => getWhatsappList(currentPage)}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltipsubmit"
                    >
                      Submit
                    </UncontrolledTooltip>
                    <Button
                      className=" btn-primary  btn-simple btn-icon btn-round mt-4"
                      color="primary"
                      data-placement="top"
                      id="tooltippdf"
                      type="button"
                      onClick={() => generateXcel(currentPage)}
                    >
                      <i className="tim-icons icon-cloud-download-93" />
                    </Button>
                   
                    <UncontrolledTooltip
                      delay={0}
                      placement="top"
                      target="tooltippdf"
                    >
                      Export
                    </UncontrolledTooltip>
                  </Col>

                  
                </Row>
              
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
            <Row>
                  <Col md="10"></Col>
                <Col md="2" sm="12" >
                    <MDBInput
                      label="Search"
                      placeholder="enter mobile number"
                      type="text"
                      onChange={(e) => filterData(e)}
                    />
                  </Col>
                </Row>
              <CardBody className="mb-0">
             
                <TableContainer component={Paper} className="tableheight">
                  <Table
                    sx={{  paddingBottom: 0 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th >S no </th>
                        <th > Date Time</th>
                        <th > Mobile No</th>
                        <th> Sender </th>
                        <th> Submit Error</th>
                        <th> System Id</th>
                        <th>Status</th>
                        <th> Deliver Error</th>

                       
                      </tr>

                    </thead>
                    <tbody>
                      {whatsappLst?.message?.length > 0 ? (
                        whatsappLst?.message?.map((item, index) => {
                          return (
                            <>
                              <tr>
                                <td style={{width:"8%"}}>{index+1}</td>
                                <td style={{width:"15%"}}>{moment(item.deliverTime).format("YYYY-MM-DD H:m")}</td>
                                <td>{item.msisdn}</td>
                                <td>{item.sender}</td>
                                <td>{item.submit_error}</td>
                                <td>{item.systemId}</td>
                                <td>{item.STATUS}</td>
                                <td>{item.DLError}</td>

                                
                              </tr>
                            </>
                          );
                        })
                      ) : (
                        <tr>
                          <td colspan="8">No Records To Display</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
             { whatsappLstC?.numOfPages>0&&
        <div style={{width:"30%",marginLeft: "auto"}}>
        <ResponsivePagination
      current={currentPage}
      total={whatsappLstC?.numOfPages}
      onPageChange={(newPage )=>{getWhatsappList(newPage)}}
    />
    </div>
} 
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Detailedreports;
